import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { Item } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type PaymentMethodsProps = {
  paymentMethods: Item[] | undefined
}

export function PaymentMethods(props: PaymentMethodsProps) {
  const { formatList } = useIntl()
  const { paymentMethods } = props

  if (!paymentMethods?.length) return null

  const processTooltip = () =>
    formatList(paymentMethods.map((pm) => pm.name) ?? [])

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.paymentMethods.title} />
      </Tag>
    </Tooltip>
  )
}
